export default __webpack_public_path__ + "static/media/06.7ac55bc9.jpg";